import { Component, EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';

@Component({
    selector: 'app-wedding-rsvp-admin',
    templateUrl: './wedding-rsvp-admin.component.html',
    styleUrls: ['./wedding-rsvp-admin.component.scss'],
    standalone: false
})
export class WeddingRsvpAdminComponent {
  rsvps: any[] = [];

  private injector = inject(EnvironmentInjector);

  constructor(private db: AngularFireDatabase) {
    this.getRSVPs();
  }

  private inCtx<T>(fn: () => T): T {
    return runInInjectionContext(this.injector, fn);
  }

  getRSVPs() {
    this.inCtx(() => this.db.list('/wedding-rsvp').valueChanges()).subscribe((list: any[]) => {
      this.rsvps = list;
    });
  }
}
